var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoResults = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 100,
  height: 100,
  viewBox: "0 0 128 128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7780_19022)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 60.7768,
  cy: 62.7768,
  r: 60.7768,
  fill: "#CFEFFB"
}), /*#__PURE__*/React.createElement("circle", {
  opacity: 0.2,
  cx: 60.7767,
  cy: 62.7767,
  r: 47.2709,
  fill: "#0090C1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.029 103.448H32.6552C31.1888 103.448 30 102.26 30 100.793V24.6552C30 23.1888 31.1888 22 32.6552 22H76.6726L91.6842 35.8569V100.793C91.6842 102.26 90.4955 103.448 89.029 103.448Z",
  fill: "#F5F8FF",
  stroke: "#A7B2CD",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.7852 39.0239C36.7852 38.0145 37.6034 37.1963 38.6127 37.1963H73.9995C75.0089 37.1963 75.8271 38.0145 75.8271 39.0239C75.8271 40.0332 75.0089 40.8515 73.9995 40.8515H38.6127C37.6034 40.8515 36.7852 40.0332 36.7852 39.0239ZM36.7852 50.2888C36.7852 49.2794 37.6034 48.4612 38.6127 48.4612H84.2731C85.2825 48.4612 86.1007 49.2794 86.1007 50.2888C86.1007 51.2981 85.2825 52.1164 84.2731 52.1164H38.6127C37.6034 52.1164 36.7852 51.2981 36.7852 50.2888ZM36.7852 61.5537C36.7852 60.5443 37.6034 59.7261 38.6127 59.7261H51.1693C52.1787 59.7261 52.9969 60.5443 52.9969 61.5537C52.9969 62.563 52.1787 63.3813 51.1693 63.3813H38.6127C37.6034 63.3813 36.7852 62.563 36.7852 61.5537ZM57.3323 61.5537C57.3323 60.5443 58.1506 59.7261 59.1599 59.7261H84.2731C85.2825 59.7261 86.1007 60.5443 86.1007 61.5537C86.1007 62.563 85.2825 63.3813 84.2731 63.3813H59.1599C58.1506 63.3813 57.3323 62.563 57.3323 61.5537ZM36.7852 72.8186C36.7852 71.8092 37.6034 70.991 38.6127 70.991H71.7165C72.7259 70.991 73.5441 71.8092 73.5441 72.8186C73.5441 73.8279 72.7259 74.6461 71.7165 74.6461H38.6127C37.6034 74.6461 36.7852 73.8279 36.7852 72.8186ZM77.8795 72.8186C77.8795 71.8092 78.6977 70.991 79.7071 70.991H84.2731C85.2825 70.991 86.1007 71.8092 86.1007 72.8186C86.1007 73.8279 85.2825 74.6461 84.2731 74.6461H79.7071C78.6977 74.6461 77.8795 73.8279 77.8795 72.8186ZM36.7852 82.957C36.7852 81.9476 37.6034 81.1294 38.6127 81.1294H80.8486C81.8579 81.1294 82.6762 81.9476 82.6762 82.957C82.6762 83.9663 81.8579 84.7846 80.8486 84.7846H38.6127C37.6034 84.7846 36.7852 83.9663 36.7852 82.957ZM36.7852 93.0954C36.7852 92.086 37.6034 91.2678 38.6127 91.2678H69.4335C70.4428 91.2678 71.2611 92.086 71.2611 93.0954C71.2611 94.1047 70.4428 94.923 69.4335 94.923H38.6127C37.6034 94.923 36.7852 94.1047 36.7852 93.0954Z",
  fill: "#E4E7F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.7852 39.0239C36.7852 38.0145 37.6034 37.1963 38.6127 37.1963H73.9995C75.0089 37.1963 75.8271 38.0145 75.8271 39.0239C75.8271 40.0332 75.0089 40.8515 73.9995 40.8515H38.6127C37.6034 40.8515 36.7852 40.0332 36.7852 39.0239Z",
  fill: "#E4E7F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.0635 21L92.6841 35.4191H81.0635C78.8543 35.4191 77.0635 33.6282 77.0635 31.4191V21Z",
  fill: "#A7B2CD"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.3412,
  cy: 58.3412,
  r: 4.3412,
  stroke: "#E66A8B",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116.608,
  cy: 71.6078,
  r: 3.60776,
  stroke: "#11BC97",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10.1101,
  cy: 79.1101,
  r: 1.11008,
  stroke: "#0090C1",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.7396 89.7785L89.6901 83.8279L114.211 104.757C117.214 107.32 117.395 111.899 114.603 114.691C111.811 117.483 107.232 117.302 104.669 114.299L83.7396 89.7785Z",
  fill: "#110133"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.9644 94.7286L104.669 114.299C107.232 117.303 111.811 117.483 114.603 114.691C117.395 111.9 117.214 107.32 114.211 104.757L92.3639 86.1104C91.4848 89.2798 89.9717 92.1977 87.9644 94.7286Z",
  fill: "#110133"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.627 59.0059C61.8268 60.8284 59.6087 63.4653 58.2625 66.5903C56.9161 69.716 56.5054 73.1834 57.0854 76.5518C57.6654 79.9199 59.2081 83.0286 61.5093 85.4876C63.8099 87.9458 66.7644 89.6439 69.9951 90.3772C73.2254 91.1104 76.596 90.8485 79.6835 89.6223L79.6838 89.6222C81.7348 88.8079 83.6128 87.587 85.209 86.026C86.8054 84.465 88.0886 82.5944 88.9824 80.5194C89.8763 78.4444 90.3624 76.2074 90.4113 73.9367C90.4602 71.666 90.071 69.4089 89.2671 67.2949L89.267 67.2947C88.0567 64.1107 85.9537 61.375 83.2336 59.4269C80.5142 57.4794 77.2979 56.4043 73.9914 56.3296C70.685 56.255 67.4264 57.1839 64.627 59.0059ZM53.088 64.3613C54.8678 60.2295 57.8106 56.7199 61.5536 54.2838C65.2973 51.8472 69.6702 50.5964 74.1186 50.6969C78.567 50.7973 82.8806 52.2441 86.5141 54.8463C90.1468 57.448 92.9343 61.0856 94.5335 65.2926C95.5958 68.0863 96.1087 71.0646 96.0442 74.0581C95.9797 77.0517 95.3389 80.0045 94.157 82.7484C92.9749 85.4925 91.2739 87.9756 89.1482 90.0543C87.0224 92.1331 84.5135 93.7667 81.7631 94.8587C77.6203 96.5039 73.0901 96.8572 68.748 95.8717C64.4064 94.8863 60.4571 92.6088 57.3956 89.3375C54.3346 86.0668 52.2976 81.9491 51.5329 77.5079C50.7682 73.0669 51.3083 68.4927 53.088 64.3613Z",
  fill: "#110133"
}), /*#__PURE__*/React.createElement("rect", {
  width: 10.8561,
  height: 1.87174,
  rx: 0.935869,
  transform: "matrix(-0.707107 0.707107 0.707107 0.707107 44.6763 109)",
  fill: "#110133"
}), /*#__PURE__*/React.createElement("rect", {
  width: 10.8561,
  height: 1.87174,
  rx: 0.935869,
  transform: "matrix(0.707107 0.707107 0.707107 -0.707107 37 110.323)",
  fill: "#110133"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7780_19022"
}, /*#__PURE__*/React.createElement("rect", {
  width: 128,
  height: 128,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoResults);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-results.9040721e3ccf81f54ae2e425157c3a2d.svg";